import BaseConstants from '@shared/constants/BaseConstants';
import { TEST_ID as SIGN_IN_TEST_ID } from './sign-in/sign-in.constants';
import { TEST_ID as SIGN_UP_TEST_ID } from './sign-up/sign-up.constants';
import {
    TEST_ID as CHALLENGE_NEW_PASSWORD_REQUIRED_TEST_ID,
} from './challenge-new-password-required/challenge-new-password-required.constants';

export const ROUTES = {
    SIGN_IN: '/auth/sign-in',
    CHALLENGE_NEW_PASSWORD_REQUIRED: '/auth/join-team',
    CHALLENGE_SMS_MFA: '/auth/confirm-sms-mfa',
    CHALLENGE_SOFTWARE_TOKEN_MFA: '/auth/confirm-token-mfa',
    SIGN_UP_LOADING: '/auth/sign-up-loading',
    SIGN_UP: '/auth/sign-up',
    SIGN_UP_SINGLE_PAGE: '/auth/single-page-sign-up',
    SIGN_UP_CONFIRMATION: '/auth/confirm-sign-up',
    SIGN_OUT: '/auth/sign-out',
    FORGOT_PASSWORD: '/auth/forgot-password',
    CONFIRM_FORGOT_PASSWORD: '/auth/confirm-forgot-password',
    CONFIRM_INVITE: '/auth/confirm-invite/:username/:token?',
    SPLASH_SCREEN: '/auth/setup',
    UPDATE_SIGN_UP_DATA: '/auth/update-sign-up-data',
};

export const SIGN_UP_TEXTS = {
    passwordValidation: gettext('The password has to contain at least 8 charachters'),
    phone: gettext('Phone'),
    byContinuing: gettext('By continuing, you agree to the '),
    termsAndPrivacy: gettext('Terms of Service and Privacy Policy'),
    aboutYour: gettext('About your '),
    signIn: gettext('Sign In'),
    createAccount: gettext('Create Account'),
    meetTess: gettext('Create your profile to meet Tess right now'),
    createProfileToJoinTeam: gettext('Create your profile and join your team at Pareto Ads'),
    joinYourTeam: gettext('Join Your Team'),
    email: gettext('Email'),
    register: gettext('Register'),
    password: gettext('Password'),
    confirmPassword: gettext('Confirm password'),
    yourName: gettext('Your name'),
    yourPhone: gettext('Your phone'),
    connectYourNewAI: gettext('Connect Your New Artificial Intelligence'),
    connectTessWithYourCompany: gettext('Connect Tess (Your AI) with your company data so she can learn about your market'),
    companyName: gettext('Company name'),
    businessType: gettext('Business type'),
    size: gettext('Size'),
    createMyAI: gettext('Create My AI'),
    required: gettext('Required'),
    whatsYourPosition: gettext('What is your position ?'),
    whatsYourCompanySize: gettext('What is your company size?'),
    howManyUsers: gettext('Users'),
    next: gettext('Next'),
    firstAndOnly: gettext('1st and Only'),
    googleAdsRiskScore: gettext('Google Ads Risk Score'),
    improvingYour: gettext('Improving your '),
    experience: gettext('experience'),
    notJustTool: gettext('Not just a tool. Your marketing partner.'),
    whatsYourObjective: gettext("What's your objective ?"),
    howMuchInvestment: gettext('How much do you invest in digital media monthly?'),
    whichSector: gettext('Which is the sector of your company/business ?'),
    crossChannel: gettext('Cross Channel'),
    budgetManagement: gettext('Budget Management'),
    integrate: gettext('Integrate '),
    connectPlatforms: gettext('Your Google and Facebook Ads Account '),
    connectYourGoogleAdsAccount: gettext('Connect your Google Ads Account'),
    connectYourFacebookAdsAccount: gettext('Connect your Facebook Ads Account'),
    skip: gettext('Skip'),
    logout: gettext('Logout'),
    goBack: gettext('Go Back'),
    finish: gettext('Finish'),
    firstAIMarketingManager: gettext('Tess is the first AI Marketing Manager'),
    youAreCreatingYourAINow: gettext('You Are Creating Your AI Now'),
};

export const COMPANY_SECTOR_NAME = [{
    value: BaseConstants.COMPANY_NAME.AGENCIES,
    label: gettext('Agencies'),
}, {
    value: BaseConstants.COMPANY_NAME.APPS,
    label: gettext('Apps'),
}, {
    value: BaseConstants.COMPANY_NAME.ARCHITECTURE_AND_INTERIOR_DESIGN,
    label: gettext('Architecture and Interior Design'),
}, {
    value: BaseConstants.COMPANY_NAME.AUTOMOBILES,
    label: gettext('Automobiles'),
}, {
    value: BaseConstants.COMPANY_NAME.BAGS_AND_CASES,
    label: gettext('Bags & Cases'),
}, {
    value: BaseConstants.COMPANY_NAME.BEACH_FASHION,
    label: gettext('Beach Fashion'),
}, {
    value: BaseConstants.COMPANY_NAME.BEAUTY,
    label: gettext('Beauty'),
}, {
    value: BaseConstants.COMPANY_NAME.BOOKS_AND_BOOKSTORES,
    label: gettext('Books & Bookstores'),
}, {
    value: BaseConstants.COMPANY_NAME.CLEANING,
    label: gettext('Cleaning'),
}, {
    value: BaseConstants.COMPANY_NAME.CLOTHING_AND_SHOES,
    label: gettext('Clothing & Shoes'),
}, {
    value: BaseConstants.COMPANY_NAME.CONSULTING,
    label: gettext('Consulting'),
}, {
    value: BaseConstants.COMPANY_NAME.COUPON_AND_COLLECTIBLE_SHOPPING,
    label: gettext('Coupon & Collectible Shopping'),
}, {
    value: BaseConstants.COMPANY_NAME.EDUCATION,
    label: gettext('Education'),
}, {
    value: BaseConstants.COMPANY_NAME.ELECTRONICS,
    label: gettext('Electronics'),
}, {
    value: BaseConstants.COMPANY_NAME.ENGINEERING,
    label: gettext('Engineering'),
}, {
    value: BaseConstants.COMPANY_NAME.ENTERTAINMENT,
    label: gettext('Entertainment'),
}, {
    value: BaseConstants.COMPANY_NAME.EVENTS_AND_SERVICES_FOR_EVENTS,
    label: gettext('Events & Services'),
}, {
    value: BaseConstants.COMPANY_NAME.FINANCIAL_SERVICES,
    label: gettext('Financial Services'),
}, {
    value: BaseConstants.COMPANY_NAME.FLORICULTURE_AND_LANDSCAPING,
    label: gettext('Floriculture & Landscaping'),
}, {
    value: BaseConstants.COMPANY_NAME.FOODS_AND_DRINKS,
    label: gettext('Foods & Drinks'),
}, {
    value: BaseConstants.COMPANY_NAME.FURNITURE,
    label: gettext('Furniture'),
}, {
    value: BaseConstants.COMPANY_NAME.HEALTH_AND_WELLNESS,
    label: gettext('Health & Wellness'),
}, {
    value: BaseConstants.COMPANY_NAME.HOME_AND_KITCHEN,
    label: gettext('Home & Kitchen'),
}, {
    value: BaseConstants.COMPANY_NAME.HOME_APPLIANCES,
    label: gettext('Home appliances'),
}, {
    value: BaseConstants.COMPANY_NAME.INDUSTRY,
    label: gettext('Industry'),
}, {
    value: BaseConstants.COMPANY_NAME.INTERNET,
    label: gettext('Internet'),
}, {
    value: BaseConstants.COMPANY_NAME.INSURANCE,
    label: gettext('Insurance'),
}, {
    value: BaseConstants.COMPANY_NAME.LEGAL,
    label: gettext('Legal'),
}, {
    value: BaseConstants.COMPANY_NAME.NGO_CROWDFUNDING,
    label: gettext('NGO / Crowdfunding'),
}, {
    value: BaseConstants.COMPANY_NAME.PET,
    label: gettext('Pet'),
}, {
    value: BaseConstants.COMPANY_NAME.PROPERTIES,
    label: gettext('Properties'),
}, {
    value: BaseConstants.COMPANY_NAME.SAAS,
    label: gettext('SaaS'),
}, {
    value: BaseConstants.COMPANY_NAME.SEX_SHOP,
    label: gettext('Sex Shop'),
}, {
    value: BaseConstants.COMPANY_NAME.SOFTWARE_HARDWARE_AND_SERVICE,
    label: gettext('Software / Hardware & Service'),
}, {
    value: BaseConstants.COMPANY_NAME.SPORT,
    label: gettext('Sport'),
}, {
    value: BaseConstants.COMPANY_NAME.TELECOM,
    label: gettext('Telecom'),
}, {
    value: BaseConstants.COMPANY_NAME.TOURISM,
    label: gettext('Tourism'),
}, {
    value: BaseConstants.COMPANY_NAME.TOYS,
    label: gettext('Toys'),
}, {
    value: BaseConstants.COMPANY_NAME.TRANSPORTATION_AND_WAREHOUSING,
    label: gettext('Transportation & Warehousing'),
}, {
    value: BaseConstants.COMPANY_NAME.UNDERWEAR,
    label: gettext('Underwear'),
}];

export const ROLE_NAMES = [{
    value: 'associate_founder',
    label: gettext('Associate / Founder'),
}, {
    value: 'director',
    label: gettext('Director'),
}, {
    value: 'manager',
    label: gettext('Manager'),
}, {
    value: 'coordinator',
    label: gettext('Coordinator'),
}, {
    value: 'analyst',
    label: gettext('Analyst'),
}, {
    value: 'other',
    label: gettext('Other'),
}];

export const TEST_ID = {
    SIGN_IN_TEST_ID,
    SIGN_UP_TEST_ID,
    CHALLENGE_NEW_PASSWORD_REQUIRED_TEST_ID,
    CHALLENGE_NEW_PASSWORD_REQUIRED_PAGE: 'CHALLENGE_NEW_PASSWORD_REQUIRED_PAGE',
    CHALLENGE_SMS_MFA_PAGE: 'CHALLENGE_SMS_MFA_PAGE',
    CHALLENGE_SOFTWARE_TOKEN_MFA_PAGE: 'CHALLENGE_SOFTWARE_TOKEN_MFA_PAGE',
};
